import {ValidacaoService} from './../../service/validacao.service';
import {ToadMensagemService} from './../../service/toad-mensagem.service';
import {FormBuilder, NgForm} from '@angular/forms';
import {CatalogoApiService} from './../../service/api/catalogo.api';
import {PesquisasFiltroApiService} from './../../service/api/pesquisas-filtro.api';
import {GlobalService} from './../../service/global.service';
import {ModalService} from './../../service/modal.service';
import {
    FTA,
    Evento,
    EventoTransmissao,
    OrigemTransmissao,
    Cliente,
    InstalacaoProduto,
    DestinoTransmissao,
    Parametro,
    ParametroConteudo,
    MCI,
    UOR,
    UserAplicacao,
    ItemConfiguracao,
    ParametroEntradaInstalacaoProduto,
    Layout
} from './../../model/catalogo';
import {Component, OnInit, Output, EventEmitter, Input, Injectable, ViewChild, HostListener} from '@angular/core';


import {SelectItem} from 'primeng/api';
import {Escopos} from './../../model/usuario';
import {HttpClient} from '@angular/common/http';
import {UtilApi} from '../../service/api/util.api';


import {FtaService} from '../../service/fta.service';
import {WizardComponent} from 'angular-archwizard';
import {JQueryStatic} from 'jquery';
import {FiltrosDeLayout, ResultadoFiltroLayout} from '../../model/filtros';

declare var $: JQueryStatic;

@Component({
    selector: 'app-detalhe-evento-transmissao',
    templateUrl: './detalhe-evento-transmissao.component.html',
    styleUrls: ['./detalhe-evento-transmissao.component.css'],
    providers: [ValidacaoService]
})


@Injectable()
export class DetalheEventoTransmissaoComponent implements OnInit {

    constructor(
        public http: HttpClient,
        private utilApi: UtilApi,
        private messageService: ToadMensagemService,
        private formBuilder: FormBuilder,
        private modalService: ModalService,
        private catalogoApi: CatalogoApiService,
        public globalService: GlobalService,
        public pesquisaService: PesquisasFiltroApiService,
        public ftaService: FtaService,
        private validacaoService: ValidacaoService,
        @ViewChild(WizardComponent)
        public wizard: WizardComponent
    ) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13 && this.novoEventoTransmissao != undefined && $('#modalEvento').hasClass('in')) {
                this.finishFunction();
            }
        }
    }

    parmTransmissao: Array<Parametro> = new Array<Parametro>();
    parametrosSelecionados: any;
    listaParmEntradaTransmissaoComProduto: Array<ParametroEntradaInstalacaoProduto> = new Array<ParametroEntradaInstalacaoProduto>();
    selecionado: ParametroEntradaInstalacaoProduto = new ParametroEntradaInstalacaoProduto();
    listaParametroConteudo: Array<ParametroConteudo> = new Array<ParametroConteudo>();
    resultadosLayout: ResultadoFiltroLayout = new ResultadoFiltroLayout();
    resultado: ItemConfiguracao = new ItemConfiguracao();
    transmissao: EventoTransmissao = new EventoTransmissao();
    origemTransmissao: OrigemTransmissao = new OrigemTransmissao();
    destinoTransmissao: DestinoTransmissao = new DestinoTransmissao();
    parametro: Parametro = new Parametro();
    clienteOrigem: Cliente = new Cliente();
    clienteDestino: Cliente = new Cliente();
    instalacaoProdutoOrigem: InstalacaoProduto = new InstalacaoProduto();
    instalacaoProdutoDestino: InstalacaoProduto = new InstalacaoProduto();
    mci: MCI = new MCI();
    uor: UOR = new UOR();
    userAplicacao: UserAplicacao = new UserAplicacao();
    novoParametroConteudo: ParametroConteudo = new ParametroConteudo();
    // parmTransmissao: Parametro = new Parametro();
    outroParametro: Parametro = new Parametro();
    contador = 0;
    listaClienteOrigem: Array<OrigemTransmissao> = new Array<OrigemTransmissao>();

    @Output() transmissaoAdicionada = new EventEmitter();
    @Output() eventoAlterado = new EventEmitter();
    @Output() eventoCancelado = new EventEmitter();

    @Input() novoEventoTransmissao: EventoTransmissao;
    @Input() evento: Evento;
    @Input() fta: FTA;

    parametroNome: string;
    parmNome: string;
    parmConteudo: string;
    ultimoId = 0;
    conteudo: string;
    chaveComposta: any;

    listaParm = [];
    listaItemConfiguracaoProduto = [];
    cols: any[];
    lista = [];

    loadingTablePrincipal = false;
    habilitarOrigem = false;
    habilitarOrigemProduto = false;
    habilitarDestino = false;
    habilitarDestinoProduto = false;

    nomeOrigemSelecionado = '';
    nomeDestinoSelecionado = '';
    nomeOrigemInstalacaoProduto = '';
    nomeDestinoInstalacaoProduto = '';
    campoParmNome: string;
    campoParmConteudo: string;
    paramentoConteudo: string;
    validaCampo = false;

    listaItens: Array<EventoTransmissao> = new Array<EventoTransmissao>();
    listaParametro: Array<Parametro> = new Array<Parametro>();

    nomeSubtipoDado: string;
    eventoSelecionado = false;
    eventoLocal: Evento;
    selectedRange: any;
    caracteresInvalidos = '';
    pagina = 1;

    escopos: Array<Escopos> = new Array<Escopos>();
    escoposLabel: SelectItem[];

    ngOnInit() {

        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, DetalheEventoTransmissaoComponent.prototype.carregarConstantes);

        this.cols = [
            {field: 'nome', header: 'Nome'},
            {field: 'descricao', header: 'Descrição'},
            {field: 'nomeTipoDado', header: 'Tipo'},
            {field: 'nomeSubtipoDado', header: 'SubTipo'},
            {field: 'obrigatorio', header: 'Obrig.'},
            {field: 'conteudoPadrao', header: 'Conteúdo Padrão'}
        ];

        /*
        this.listaItemConfiguracaoProduto = [
          { codigo: 1, descricao: 'PESIT' },
          { codigo: 2, descricao: 'Odette' },
          { codigo: 3, descricao: 'SIA' },
          { codigo: 4, descricao: 'Connect_Direct' },
          { codigo: 5, descricao: 'AS2'}
        ];
        */
        this.filtrarLayouts();
        this.buscarItemConfiguracao();

    }

    // Um método de retorno uma chamada que executa a detecção de alterações
    ngDoCheck(): void {
        if (this.novoEventoTransmissao != undefined) {
            this.transmissao = new EventoTransmissao();
            this.transmissao = this.novoEventoTransmissao;
            this.parmTransmissao = this.novoEventoTransmissao.parmTransmissao;
            //this.transmissaoAdicionada.emit(this.transmissao);
        }
    }

    ngOnChanges(): void {
        this.eventoLocal = this.evento;
        //this.eventoLocal.detalheEventoTransmissao = this.transmissao

        if (this.fta.fta != null || this.fta.fta != 0) {
            setTimeout(() => {
                this.buscaConfiguracaoProduto(true);
            }, 1000);
        }
    }


    salvarTransformacao() {

        if (this.evento.parametrosSelecionados) {

            this.evento.detalheEventoTransmissao.parmTransmissao = [];

            // if(!this.evento.detalheEventoOperacao) {
            //   this.evento.detalheEventoTransmissao =  {...this.evento.detalheEventoTransmissao, parmTransmissao: []}
            // } else {
            //   this.evento.detalheEventoTransmissao.parmTransmissao = []
            // }

            this.evento.parametrosSelecionados.reduce((ids: any, thing: any) => {
                if (thing.selecionado == true) {

                    if (thing.nomeSubtipoDado) {
                        const {
                            conteudoPadrao,
                            descricao,
                            nomeSubtipoDado,
                            nomeTipoDado,
                            obrigatorio,
                            parmConteudo,
                            parmNome,
                            selecionado
                        } = thing;

                        if ((thing.nomeSubtipoDado == 'sel_excl' || thing.nomeSubtipoDado == 'sel_mult') && thing.nomeTipoDado != 'boolean') {
                            this.evento.detalheEventoTransmissao.parmTransmissao.push({
                                conteudoPadrao,
                                descricao,
                                nomeSubtipoDado,
                                nomeTipoDado,
                                obrigatorio,
                                'parmConteudo': conteudoPadrao,
                                parmNome,
                                selecionado
                            });

                        } else {
                            this.evento.detalheEventoTransmissao.parmTransmissao.push({
                                conteudoPadrao,
                                descricao,
                                nomeSubtipoDado,
                                nomeTipoDado,
                                obrigatorio,
                                'parmConteudo': parmConteudo,
                                parmNome,
                                selecionado
                            });
                        }
                        this.evento.listaParametrosSelecionados = this.evento.detalheEventoTransmissao.parmTransmissao;
                        this.transmissaoAdicionada.emit(this.transmissao);
                    }
                }
            }, []);
        }
    }

    getEscopos() {
        const url = this.globalService.getConfiguracao().api_autorizador + '/usuario/escopo';

        this.http.get(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                response => {
                    this.escopos = response as Escopos[];
                    this.escopos.forEach(obj => {
                        this.escoposLabel.push({label: obj.nmEscopo, value: obj.codEscopo});
                    });

                }
            ).catch(
            error => {
                // this.exibirMensagemErro(error)
            }
        );
    }

    carregarConstantes() {
        this.getEscopos();
    }

    buscarItemConfiguracao() {
        this.globalService.loading = true;
        const filtros: Array<any> = new Array<any>();
        filtros.push({'filtroItemConfiguracao': {'tipoItemConfiguracao': 1}});
        this.pesquisaService.filtraItemConfiguracao(filtros)
            .subscribe(
                listaItens => {
                    this.listaItemConfiguracaoProduto = listaItens;

                    //tranforma nomes em maiusculo
                    //this.listaItemConfiguracaoProduto = this.listaItemConfiguracaoProduto.map((item) => ({ ...item, nome: item.nome.toUpperCase() }));

                    //ordena resultados
                    this.listaItemConfiguracaoProduto.sort(function (a, b) {
                        if (a.nome < b.nome) {
                            return -1;
                        }
                        if (a.nome > b.nome) {
                            return 1;
                        }
                        return 0;
                    });

                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404) {
                        this.listaItemConfiguracaoProduto = new Array<ItemConfiguracao>();
                    }
                }
            );
    }

    finishFunction() {
        if (this.validacaoService.validaEvento(this.eventoLocal)) {

            //limpa campo de parametros
            this.selectedRange = '';
            this.eventoSelecionado = false;

            this.eventoAlterado.emit(true);
            this.wizard.navigation.reset();
        }
    }

    filtrarLayouts() {
        const filtros: Array<any> = new Array<any>();
        this.pesquisaService.filtraOperacao(filtros);
        this.globalService.loading = true;
        this.pesquisaService.filtraLayoutPaginado(this.getFiltros())
            .subscribe(
                listaItens => {
                    this.globalService.loading = false;
                    this.resultadosLayout = listaItens as ResultadoFiltroLayout;
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404) {
                        this.resultadosLayout.layouts = new Array<Layout>();
                    }
                    this.globalService.loading = false;
                }
            );
    }

    getFiltros() {
        const filtros = new FiltrosDeLayout();
        return filtros;
    }

    salvar() {
        $('#btnSalvarTransmissao').click();
    }

    cancelarEvento() {
        //limpa campo de parametros
        this.selectedRange = '';
        this.eventoSelecionado = false;
        this.eventoCancelado.emit(this.evento);
    }

    definirLayoutArquivo() {
        for (let i = 0; i <= this.resultadosLayout.layouts.length; i++) {
            if (this.resultadosLayout.layouts[i]) {
                if (this.resultadosLayout.layouts[i].codigo == this.transmissao.codLayout) {
                    this.transmissao.codLayout = this.resultadosLayout.layouts[i].codigo;
                    this.transmissao.vrsLayout = this.resultadosLayout.layouts[i].versao;
                    this.transmissao.nomeLayout = this.resultadosLayout.layouts[i].nome;
                }
            }
        }
    }

    onLinhaSelecionada(event) {
    }

    // método que busca o produto usando a API Rest
    buscaConfiguracaoProduto(isEdicao: boolean) {
        this.contador = 0;

        if (this.transmissao.nomeItemConfiguracaoProduto != undefined || this.transmissao.nomeItemConfiguracaoProduto != null) {
            this.habilitarOrigem = true;
        }

        this.evento.parametrosSelecionados = [];

        const filtros: Array<any> = new Array<any>();
        if (this.transmissao.nomeItemConfiguracaoProduto != undefined) {
            filtros.push(this.transmissao.nomeItemConfiguracaoProduto);
            this.globalService.loading = true;
            this.ftaService.buscarItemConfiguracaoProduto(filtros)
                .subscribe(
                    listaItens => {
                        this.globalService.loading = false;
                        if (listaItens != null) {
                            this.resultado = listaItens;

                            let parametrosSelecionado = [];

                            if (isEdicao) {
                                parametrosSelecionado = this.evento.listaParametrosSelecionados;
                            } else {
                                parametrosSelecionado = this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto;
                            }

                            if (parametrosSelecionado) {
                                parametrosSelecionado.map(item => {
                                    this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto.map((resultado, index) => {
                                        if (item.parmNome == resultado.nome && item.nomeSubtipoDado == 'sel_excl') {
                                            const r1 = this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[index].conteudoPadrao;
                                            const r2 = item.parmConteudo;

                                            const apenasNoR2 = r2.filter(function (element, index, array) {
                                                if (r1.indexOf(element.conteudo) == -1) {
                                                    return element.conteudo;
                                                }
                                            });

                                            apenasNoR2.map(conteudo => {
                                                this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto[index].conteudoPadrao.push(conteudo.conteudo);
                                            });
                                        }
                                    });
                                });
                            }

                            if (parametrosSelecionado) {
                                parametrosSelecionado = parametrosSelecionado.sort(function (a, b) {
                                    return (a.parmNome > b.parmNome) ? 1 : ((b.parmNome > a.parmNome) ? -1 : 0);
                                });
                            }
                            this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto = this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto.sort(function (a, b) {
                                return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0);
                            });

                            this.evento.parametrosSelecionados = [];

                            this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto.map((parmEntradaTransmissaoComProduto: any) => {
                                const conteudoPadrao = [];

                                parmEntradaTransmissaoComProduto.conteudoPadrao.map((valor, key) => {
                                    conteudoPadrao.push({
                                        'selecionado': false,
                                        'nrPosicao': key,
                                        'conteudo': valor
                                    });
                                });

                                if (Array.isArray(parametrosSelecionado)) {
                                    parametrosSelecionado.map((parametrosSelecionado: any) => {
                                        if (parametrosSelecionado.parmNome == parmEntradaTransmissaoComProduto.nome) {

                                            this.evento.parametrosSelecionados[this.contador] = {
                                                'obrigatorio': parmEntradaTransmissaoComProduto.obrigatorio,
                                                'selecionado': true,
                                                'parmNome': parmEntradaTransmissaoComProduto.nome,
                                                'nomeTipoDado': parmEntradaTransmissaoComProduto.nomeTipoDado,
                                                'nomeSubtipoDado': parmEntradaTransmissaoComProduto.nomeSubtipoDado,
                                                'descricao': parmEntradaTransmissaoComProduto.descricao,
                                                'conteudoPadrao': conteudoPadrao,
                                                'parmConteudo': []
                                            };

                                            parametrosSelecionado.parmConteudo.map((parametroSelecionado, parametroSelecionadoKey) => {
                                                this.evento.parametrosSelecionados[this.contador].parmConteudo.push({
                                                    selecionado: true,
                                                    conteudo: parametroSelecionado.conteudo,
                                                    nrPosicao: parametroSelecionadoKey,
                                                });

                                                this.evento.parametrosSelecionados[this.contador].conteudoPadrao.map((conteudoPadrao, conteudoPadraoKey) => {
                                                    if (parametroSelecionado.conteudo == this.evento.parametrosSelecionados[this.contador].conteudoPadrao[conteudoPadraoKey].conteudo) {
                                                        this.evento.parametrosSelecionados[this.contador].conteudoPadrao[conteudoPadraoKey] = {
                                                            selecionado: true,
                                                            conteudo: parametroSelecionado.conteudo,
                                                            nrPosicao: parametroSelecionadoKey,
                                                        };
                                                    }
                                                });
                                            });

                                        } else {
                                            if (Array.isArray(this.evento.parametrosSelecionados)) {
                                                const validacaoExistente = this.evento.parametrosSelecionados.reduce((key: any, parametrosSelecionadoValidacaoExistente: any) => {
                                                    if (parametrosSelecionadoValidacaoExistente.parmNome == parmEntradaTransmissaoComProduto.nome) {
                                                        return true;
                                                    }
                                                }, '');

                                                if (validacaoExistente != true) {
                                                    this.evento.parametrosSelecionados[this.contador] = {
                                                        'obrigatorio': parmEntradaTransmissaoComProduto.obrigatorio,
                                                        'selecionado': parmEntradaTransmissaoComProduto.obrigatorio,
                                                        'parmNome': parmEntradaTransmissaoComProduto.nome,
                                                        'nomeTipoDado': parmEntradaTransmissaoComProduto.nomeTipoDado,
                                                        'nomeSubtipoDado': parmEntradaTransmissaoComProduto.nomeSubtipoDado,
                                                        'descricao': parmEntradaTransmissaoComProduto.descricao,
                                                        'conteudoPadrao': conteudoPadrao,
                                                        'parmConteudo': [
                                                            {
                                                                'selecionado': false,
                                                                'nrPosicao': 0,
                                                                'conteudo': null
                                                            },
                                                        ]
                                                    };
                                                }
                                            }
                                        }
                                    });
                                }

                                this.contador++;
                            });


                            this.loadingTablePrincipal = true;

                            //ordena array de paramentros
                            this.resultado.itemConfiguracaoProduto.parmEntradaTransmissaoComProduto.sort(function (a, b) {
                                if (a.nome < b.nome) {
                                    return -1;
                                }
                                if (a.nome > b.nome) {
                                    return 1;
                                }
                                return 0;
                            });

                            //correcao de bug para gravar dados de campos checkbox e de multipla escolha
                            this.salvarTransformacao();

                            if (!isEdicao) {
                                //limpa configurações anteriores
                                this.transmissao.origem = [];
                                this.transmissao.destino = [];
                                this.parmTransmissao = [];
                                this.novoEventoTransmissao.parmTransmissao = [];
                                this.nomeOrigemSelecionado = '';
                                this.nomeDestinoSelecionado = '';
                                this.nomeOrigemInstalacaoProduto = '';
                                this.nomeDestinoInstalacaoProduto = '';
                            }
                        }
                    },
                    erro => {
                        this.globalService.loading = false;
                        if (erro.status == 404) {
                            //alert("Erro ao carregar itens.")
                        }
                    }
                );
        }

    }

    validaCheckboxSelect(parametrosSelecionado, conteudoSelecionado) {
        if (parametrosSelecionado.nomeSubtipoDado == 'sel_excl' && parametrosSelecionado.nomeTipoDado != 'boolean') {
            this.evento.parametrosSelecionados.map((dados, key) => {
                if (dados.parmNome == parametrosSelecionado.parmNome && this.evento.parametrosSelecionados[key]) {
                    this.evento.parametrosSelecionados[key].conteudoPadrao.map((dados, keyConteudo) => {

                        const {
                            selecionado,
                            nrPosicao,
                            conteudo
                        } = dados;

                        if (conteudoSelecionado.conteudo != this.evento.parametrosSelecionados[key].conteudoPadrao[keyConteudo].conteudo) {
                            this.evento.parametrosSelecionados[key].conteudoPadrao[keyConteudo] = {
                                selecionado: false,
                                nrPosicao,
                                conteudo
                            };
                        }
                    });
                }
            });
        }

        this.salvarTransformacao();
    }

    onSubmit(f: NgForm) {
        f.reset();
    }

    adicionarLinha(nome) {
        for (let i = 0; i <= this.evento.parametrosSelecionados.length; i++) {
            if (this.evento.parametrosSelecionados[i] && this.evento.parametrosSelecionados[i].parmNome == nome) {
                if (this.evento.parametrosSelecionados[i].parmConteudo) {
                    if (this.evento.parametrosSelecionados[i].parmConteudo[this.evento.parametrosSelecionados[i].parmConteudo.length - 1].conteudo) {
                        this.evento.parametrosSelecionados[i].parmConteudo[this.evento.parametrosSelecionados[i].parmConteudo.length] = {
                            'nrPosicao': this.evento.parametrosSelecionados[i].parmConteudo.length++,
                            'conteudo': null
                        };
                    } else {
                        this.modalService.exibirMensagem('Alerta!.\n',
                            `Não é possível adicionar novos campos sem que preencha o campo anterior! `
                            , 'Fechar');
                    }
                }
            }
        }
    }

    listaParametros() {
        this.evento.parametrosSelecionados = this.parmTransmissao;
    }

    msgAjuda(msg: any) {
        // this.clearMsgAjuda();

        this.modalService.exibirMensagem('Descrição do parâmetro.\n',
            `Tipo: ${msg.nomeTipoDado} <br> Subtipo: ${msg.nomeSubtipoDado} <br> Descrição: ${msg.descricao}`
            , 'Fechar');

    }

    aoAdiconarConteudo() {

        //valida tipo 'sel_excl'
        if (this.selecionado.nomeSubtipoDado == 'sel_excl' && this.selecionado.nomeTipoDado != 'boolean' && this.parmTransmissao.length >= 1) {
            for (const entry of this.parmTransmissao) {
                if (this.campoParmNome == entry.parmNome && entry.parmConteudo.length > 0) {
                    this.messageService.addErrorKey('O subTipo sel_excl só pode ter um tipo de conteúdo padrão.', this.chaveComposta);
                    return;
                }
            }
        }

        if (this.caracteresInvalidos.length > 0) {
            return;
        }

        this.parmTransmissao.push(this.novoParametro(this.campoParmNome, this.paramentoConteudo));

        this.transmissaoAdicionada.emit(this.transmissao);

        this.messageService.addSuccessKey('Parâmetro e conteúdo adicionado com sucesso.', this.chaveComposta);
    }

    validaCaracteresInvalidos() {
        const str = this.paramentoConteudo;
        this.caracteresInvalidos = '';
        const arrayInvalidos = '£¤¥¦§¨©ª«¬®¯°±²³µ¶·¸¹º»¼½¾¿:¡¢÷';
        for (let i = 0; i <= str.length; i++) {
            for (let j = 0; j < arrayInvalidos.length; j++) {
                if (str[i] == arrayInvalidos[j]) {
                    this.caracteresInvalidos += arrayInvalidos[j];
                }
            }
        }
    }

    novoParametro(parmNome: string, conteudo: string): Parametro {
        const parmTransmissao: Parametro = new Parametro();
        const parmConteudo: ParametroConteudo = new ParametroConteudo();
        parmTransmissao.parmConteudo = new Array<ParametroConteudo>();
        parmTransmissao.parmNome = parmNome;
        parmConteudo.nrPosicao = 0;
        parmConteudo.conteudo = conteudo;
        parmTransmissao.parmConteudo.push(parmConteudo);
        return parmTransmissao;
    }

    deletarOrigem() {
        this.clienteOrigem = null;
        this.nomeOrigemSelecionado = '';
    }

    // método que busca o cliente origem usando o (componente de modal) com a API Rest
    carregarOrigem() {
        this.modalService.abrirPaginaModal('cliente-modal', {}, {'selecionaAutomatico': true}, 'Selecionar Tipo Cliente', 'Fechar').subscribe(cliente => {
            if (cliente != null) {
                this.clienteOrigem = cliente;

                if (this.clienteOrigem.mci !== null) {
                    this.mci = this.clienteOrigem.mci;
                    this.apresentaOrigemMCI(this.mci);
                }
                if (this.clienteOrigem.uor !== null) {
                    this.uor = this.clienteOrigem.uor;
                    this.apresentaOrigemUOR(this.uor);
                } else {
                    this.userAplicacao = this.clienteOrigem.userAplicacao;
                    this.apresentaOrigemUserAplicacao(this.userAplicacao);
                }

                if (this.nomeOrigemSelecionado != undefined || this.nomeOrigemSelecionado != null) {
                    this.habilitarOrigemProduto = true;
                } else {
                    this.habilitarOrigemProduto = false;
                }
            }
        });
    }

    // método que busca o produto origem usando o (componente de modal) com a API Rest
    carregarProdutoOrigem() {

        this.modalService.abrirPaginaModal('instalacao-produto-modal', {}, {
            'cliente': JSON.stringify(this.clienteOrigem),
            'selecionaAutomatico': true,
            'cadastraNovaInstalacao': true,
            'nomeItemConfiguracao': this.transmissao.nomeItemConfiguracaoProduto
        }, 'Selecionar Produto', 'Fechar').subscribe(produto => {

            if (produto != null) {

                this.instalacaoProdutoOrigem = produto;

                if (this.instalacaoProdutoOrigem !== null) {
                    this.apresentaOrigemInstalacaoProduto(this.instalacaoProdutoOrigem);
                }

                if (this.nomeOrigemInstalacaoProduto != undefined || this.nomeOrigemInstalacaoProduto != null) {
                    this.habilitarDestino = true;
                }
            }
            //this.carregaListaOrigem();
        });
    }

    // método que lista a origem transmissão com a API Rest
    carregaListaOrigem() {

        /* adicionando Cliente Origem */
        const origem: OrigemTransmissao = new OrigemTransmissao();

        origem.clienteOrigem = this.clienteOrigem;

        /* adicionando Origem Produto */
        origem.codInstalacaoProdutoOrigem = this.instalacaoProdutoOrigem.codigo;
        origem.vrsInstalacaoProdutoOrigem = this.instalacaoProdutoOrigem.versao;
        origem.nomeInstalacaoProdutoOrigem = this.instalacaoProdutoOrigem.nomeInstalacao;

        this.transmissao.origem.push(origem);


        //limpa campos
        this.nomeOrigemSelecionado = '';
        this.nomeOrigemInstalacaoProduto = '';
    }

    deletarDestino() {
        this.clienteDestino = null;
        this.nomeDestinoSelecionado = '';
    }

    // Verifica se a instalação de produto já existe ou se deve ser inserida na base de dados
    verificarInstalacaoProduto() {
        // Instalação Origem
        if (this.instalacaoProdutoOrigem.codigo == 0) {
            this.catalogoApi.criaEditaInstalacaoProduto(0, 0, this.instalacaoProdutoOrigem)
                .subscribe(
                    resp => {
                        this.instalacaoProdutoOrigem.codigo = resp.codigoCriado;
                        this.instalacaoProdutoOrigem.versao = resp.versaoCriada;
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar o produto origem informado', 'Fechar');
                    });
        }

        // Instalação Destino
        if (this.instalacaoProdutoDestino.codigo == 0) {
            this.catalogoApi.criaEditaInstalacaoProduto(0, 0, this.instalacaoProdutoDestino)
                .subscribe(
                    resp => {
                        this.instalacaoProdutoDestino.codigo = resp.codigoCriado;
                        this.instalacaoProdutoDestino.versao = resp.versaoCriada;
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar o produto destino informado', 'Fechar');
                    });
        }
    }

    // Abre a modal cliente Destino
    carregarDestino() {
        this.modalService.abrirPaginaModal('cliente-modal', {}, {'selecionaAutomatico': true}, 'Selecionar Tipo Cliente', 'Fechar').subscribe(cliente => {
            if (cliente != null) {
                this.clienteDestino = cliente;

                if (this.clienteDestino.mci !== null) {
                    this.mci = this.clienteDestino.mci;
                    this.apresentaDestinoMCI(this.mci);
                }
                if (this.clienteDestino.uor !== null) {
                    this.uor = this.clienteDestino.uor;
                    this.apresentaDestinoUOR(this.uor);
                } else {
                    this.userAplicacao = this.clienteDestino.userAplicacao;
                    this.apresentaDestinoUserAplicacao(this.userAplicacao);
                }
            }
            if (this.nomeDestinoSelecionado != undefined || this.nomeDestinoSelecionado != null) {
                this.habilitarDestinoProduto = true;
            }
        });
    }

    // Exclui o produto origem
    deletarProdutoOrigem() {
        this.instalacaoProdutoOrigem = null;
        this.nomeOrigemInstalacaoProduto = '';
    }

    // Abre a modal produto destino
    carregarProdutoDestino() {
        this.modalService.abrirPaginaModal('instalacao-produto-modal', {}, {
            'cliente': JSON.stringify(this.clienteDestino),
            'selecionaAutomatico': true,
            'cadastraNovaInstalacao': true,
            'nomeItemConfiguracao': this.transmissao.nomeItemConfiguracaoProduto
        }, 'Selecionar Produto', 'Fechar').subscribe(produto => {
            if (produto != null) {
                this.instalacaoProdutoDestino = produto;

                if (this.instalacaoProdutoDestino !== null) {
                    this.apresentaDestinoInstalacaoProduto(this.instalacaoProdutoDestino);
                }
            }
            //this.carregaListaDestino();
        });
    }

    // seta o destino no emit evento
    carregaListaDestino() {

        /* adicionando Cliente Origem */
        const destino: DestinoTransmissao = new DestinoTransmissao();

        /* adicionando Cliente Destino */
        destino.clienteDestino = this.clienteDestino;

        /* adicionando Destino Produto */

        destino.codInstalacaoProdutoDestino = this.instalacaoProdutoDestino.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoProdutoDestino.versao;
        destino.nomeInstalacaoProdutoDestino = this.instalacaoProdutoDestino.nomeInstalacao;

        this.transmissao.destino.push(destino);

        this.transmissaoAdicionada.emit(this.transmissao);

        //limpa campos
        this.nomeDestinoSelecionado = '';
        this.nomeDestinoInstalacaoProduto = '';
    }

    deletarProdutoDestino() {
        this.instalacaoProdutoDestino = null;
        this.nomeDestinoInstalacaoProduto = '';
    }

    // remove a partir do indice informado pela linha selecionada
    remover(indice: any) {
        const testeTransmissao = this.novoEventoTransmissao;
        const index = this.parmTransmissao.indexOf(indice);
        this.parmTransmissao.splice(index, 1);
    }

    apresentaOrigemMCI(mci: MCI) {
        if (mci !== undefined || mci !== null) {
            this.nomeOrigemSelecionado = mci.codMci.toString();
            if (this.mci.nomeCliente != '') {
                this.nomeOrigemSelecionado = this.nomeOrigemSelecionado + ' - ' + mci.nomeCliente;
            }
        }
    }

    apresentaOrigemUOR(uor: UOR) {
        if (uor !== undefined || uor !== null) {
            this.nomeOrigemSelecionado = uor.codUor.toString();
            if (this.uor.nomeDependencia != '') {
                this.nomeOrigemSelecionado = this.nomeOrigemSelecionado + ' - ' + uor.nomeDependencia;
            }
        }
    }

    apresentaOrigemUserAplicacao(userAplicacao: UserAplicacao) {
        if (userAplicacao !== null) {
            this.nomeOrigemSelecionado = userAplicacao.nomeUserAplicacao;
        }
    }

    apresentaDestinoMCI(mci: MCI) {
        if (mci !== undefined || mci !== null) {
            this.nomeDestinoSelecionado = mci.codMci.toString();
            if (this.mci.nomeCliente != '') {
                this.nomeDestinoSelecionado = this.nomeDestinoSelecionado + ' - ' + mci.nomeCliente;
            }
        }
    }

    apresentaDestinoUOR(uor: UOR) {
        if (uor !== undefined || uor !== null) {
            this.nomeDestinoSelecionado = uor.codUor.toString();
            if (this.uor.nomeDependencia != '') {
                this.nomeDestinoSelecionado = this.nomeDestinoSelecionado + ' - ' + uor.nomeDependencia;
            }
        }
    }

    apresentaDestinoUserAplicacao(userAplicacao: UserAplicacao) {
        if (userAplicacao !== null) {
            this.nomeDestinoSelecionado = userAplicacao.nomeUserAplicacao;
        }
    }

    apresentaOrigemInstalacaoProduto(instalacaoProduto: InstalacaoProduto) {
        if (instalacaoProduto !== null) {
            this.nomeOrigemInstalacaoProduto = instalacaoProduto.nomeInstalacao;
        }
    }

    apresentaDestinoInstalacaoProduto(instalacaoProduto: InstalacaoProduto) {
        if (instalacaoProduto !== null) {
            this.nomeDestinoInstalacaoProduto = instalacaoProduto.nomeInstalacao;
        }
    }

    removerLinhalistaClienteOrigem(indice: any) {
        const index = this.transmissao.origem.indexOf(indice);
        this.transmissao.origem.splice(index, 1);
    }

    removerLinhalistaClienteDestino(indice: any) {
        const index = this.transmissao.destino.indexOf(indice);
        this.transmissao.destino.splice(index, 1);
    }

    // adiciona formulario do transmissão
    aoAdicionarForm() {
        this.messageService.addInfoKey('Dados adicionados com sucesso.', this.chaveComposta);
        this.transmissaoAdicionada.emit(this.transmissao);
    }

    selecionaParametro(event) {
        this.parmNome = event.value.nome;
        this.nomeSubtipoDado = event.value.nomeSubtipoDado;
        this.selecionado = event.value;
        this.eventoSelecionado = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/detalhe-evento-transmissao/detalhe-evento-transmissao.component.ts